import React from "react";
import PropTypes from 'prop-types';

import style from "./MemberCard.css";

const MemberCard = ({ member }) => {
  return (
    <div className={style.memberCard}>
      <div className={style.card}>
        <img className={style.image} src={member.image}/>
        <div className={style.info}>
          <h4 className={style.title}>{member.name}</h4>
          <div className={style.role}>{member.role}</div>
          <div className={style.quote}>
            {member.quote}
          </div>
        </div>
      </div>
    </div>
  );
};

MemberCard.propTypes = {
  member: PropTypes.object.isRequired
};

export default MemberCard;



// WEBPACK FOOTER //
// ./component/Team/MemberCard.js